import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export function ProtectedLayout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const [isAllowed, setIsAllowed] = useState<boolean | null>(null);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      const {
        data: { session }
      } = await supabase.auth.getSession();

      if (!session) {
        navigate('/');
        return;
      }

      const { data: profile } = await supabase
        .from('profiles')
        .select('beta_tester')
        .eq('id', session.user.id)
        .maybeSingle();

      setIsAllowed(true); // beta check logic is currently unnecessary
    };

    checkAccess();

    const timer = setTimeout(() => setShowLoader(true), 300);
    return () => clearTimeout(timer);
  }, [navigate]);

  if (isAllowed === null && showLoader) {
    return <div className="text-center p-6">Checking access...</div>;
  }

  if (isAllowed === null) {
    return null;
  }

  return <>{children}</>;
}
